import React,{useContext, useEffect} from 'react'
import notecontext from '../context/notes/notecontext'
import Notess from './Notess'
import bgimage from '../images/bgimage.jpg';
import bgimagehome1 from '../images/bgimagehome1.jpg';

const Home = (props) => {
  const context = useContext(notecontext)
  return (
    <>
    <div style={{ backgroundImage: `url(${bgimage})`, "height": "100vh", "width": "100vw", "position": "absolute", "backgroundSize": "cover" }}>
      
     <Notess showAlert={props.showAlert}/>
    </div>
    </>
  )
}

export default Home